import type { Locale } from "@chams-pay/contracts";
import type { ReactNode } from "react";
import { A4DocumentPreview } from "../ui/a4-document-preview.js";

export function MobileA4DocumentPreview({
  children,
  locale,
}: {
  readonly children: ReactNode;
  readonly locale: Locale;
}) {
  return (
    <div className="mobile-receipt-preview-canvas" data-document-preview-canvas dir="ltr">
      <A4DocumentPreview locale={locale} spatialDirection="ltr">
        {children}
      </A4DocumentPreview>
    </div>
  );
}
